import ApiService from "@/utils/request"

const setMerchantEnums = (uri, enumKey) => {
  return () => {
    return ApiService.query(uri).then((res) => {
      return {
        [enumKey]: res.data.map((item) => {
          const { key, value } = item
          return { value: key, label: value }
        })
      }
    })
  }
}

export const enumServe = {
  getDegreeType() {
    return ApiService.get(`alumni/enum/degree/type/`)
  },
  getDegreeStatus() {
    return ApiService.get(`alumni/enum/degree/status/`)
  },
  getSchoolType() {
    return ApiService.get(`alumni/enum/college/type/`)
  },
  merchant: {
    // 商家状态
    status: setMerchantEnums(`merchant/enum/status/type/`, "MerchantStatus"),
    // 服务类型
    service: () => {
      return ApiService.query("merchant/enum/service/type/").then((res) => {
        return {
          MerchantService: res.data.map((item) => ({
            value: item.id,
            label: item.value
          }))
        }
      })
    },
    // 优惠类型
    preferentialService: setMerchantEnums(
      `merchant/enum/preferentialService/type/`,
      "PreferentialService"
    ),
    // 周期类型
    merchantServiceTime: setMerchantEnums(
      `merchant/enum/merchantServiceTime/type/`,
      "MerchantServiceTime"
    ),
    // 有效期类型
    merchantExpire: setMerchantEnums(
      `merchant/enum/merchantExpire/type/`,
      "MerchantExpire"
    ),
    // 服务热线
    hotline: setMerchantEnums(`merchant/enum/hotline/type/`, "Hotline"),
    init() {
      const map = [
        this.status(),
        this.service(),
        this.preferentialService(),
        this.merchantServiceTime(),
        this.merchantExpire(),
        this.hotline()
      ]
      return Promise.all(map).then((list) => {
        return list.reduce((map, item) => {
          return { ...map, ...item }
        }, {})
      })
    }
  },
  allEnums() {
    return ApiService.query("dict/all_enum/")
  },
  // 获取区县列表
  commonAreas(params) {
    return ApiService.query("common/areas/", params)
  },
  // 获取街道列表
  projectStreetListQuery(params) {
    return ApiService.query("common/projectStreetList", params)
  }
}
